const STATUS_CHAT = {
    BEFOR_CHAT: 1,
    REQUIRE_PHONE: 2,
    CHATTING: 3
}

export default STATUS_CHAT
